module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5gSLI"))).then(() => module.bundle.root('f4eak'));